module.exports = __webpack_public_path__ + "static/media/energy_tempo@x2.738f5e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/energy_tempo@x2.png
// module id = 551
// module chunks = 0